export default __webpack_public_path__ + "assets/3.e4df46fb.png";